var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Bluebird from "bluebird";
import socketService from "../services/socket.service";
import Cache from "../services/Cache";
import errorService from "../services/error.service";
export var UpdateEvent;
(function (UpdateEvent) {
    UpdateEvent[UpdateEvent["wake"] = 0] = "wake";
    UpdateEvent[UpdateEvent["blink"] = 1] = "blink";
})(UpdateEvent || (UpdateEvent = {}));
export var SYMBOL_UNCHANGED = Symbol("UNCHANGED");
var LONG_APP_PAUSE = 2 * 60 * 1000;
var LONG_DISCONNECT = 60 * 1000;
function createLoader(_a) {
    var download = _a.download, load = _a.load, restore = _a.restore, getID = _a.getID, cacheName = _a.cacheName, shouldUpdate = _a.shouldUpdate;
    var loading = {};
    var byId = {};
    var cache = new Cache(cacheName);
    var considerLoaded = function (id) {
        loading = __assign({}, loading);
        delete loading[id];
    };
    var cacheInMemory = function (id, instance, lastUpdated) {
        byId = __assign({}, byId, (_a = {}, _a[id] = { instance: instance, lastUpdated: lastUpdated, updating: false }, _a));
        var _a;
    };
    var loadFromCache = function (id) {
        var lastUpdated = Date.now();
        return cache.get(id)
            .then(function (cacheResponse) {
            lastUpdated = cacheResponse.created;
            return cacheResponse.data;
        })
            .then(function (cachedData) { return restore(cachedData, null); })
            .then(function (instance) {
            cacheInMemory(id, instance, lastUpdated);
            considerLoaded(id);
            scheduleInstanceUpdate(UpdateEvent.wake, id);
            return instance;
        });
    };
    var serverResponseToInstance = function (response, id, activeInstance) {
        return Bluebird.try(function () {
            return __awaiter(this, void 0, void 0, function () {
                var loadedData, instance;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, load(response, activeInstance)];
                        case 1:
                            loadedData = _a.sent();
                            if (loadedData === SYMBOL_UNCHANGED) {
                                return [2 /*return*/, activeInstance];
                            }
                            if (loadedData instanceof Symbol) {
                                throw new Error("invalid symbol returned by load " + cacheName);
                            }
                            return [4 /*yield*/, cache.store(id, loadedData)];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, restore(loadedData, activeInstance)];
                        case 3:
                            instance = _a.sent();
                            if (activeInstance && activeInstance !== instance) {
                                console.warn("Restore should update active instance");
                            }
                            cacheInMemory(id, instance, Date.now());
                            return [2 /*return*/, instance];
                    }
                });
            });
        }).finally(function () { return considerLoaded(id); });
    };
    var updateInstance = function (id, instance) {
        return download(id, instance).then(function (response) {
            return serverResponseToInstance(response, id, instance);
        });
    };
    var scheduleInstanceUpdate = function (event, id) {
        var _a = byId[id], instance = _a.instance, lastUpdated = _a.lastUpdated, updating = _a.updating;
        if (updating) {
            console.info("Not updating instance because update is already running " + cacheName + "/" + id);
            return;
        }
        byId[id].updating = true;
        shouldUpdate(event, instance, lastUpdated).then(function (shouldUpdate) {
            if (shouldUpdate) {
                console.info("Schedule " + cacheName + " instance " + id + " update with event " + UpdateEvent[event]);
                return updateInstance(id, instance).then(function () {
                    return byId[id].lastUpdated = Date.now();
                });
            }
        }).catch(errorService.criticalError).finally(function () { return byId[id].updating = false; });
        return;
    };
    var scheduleInstancesUpdate = function (event) {
        console.info("Schedule " + cacheName + " instances update with event " + UpdateEvent[event]);
        Object.keys(byId)
            .forEach(function (id) { return scheduleInstanceUpdate(event, id); });
    };
    var lastHeartbeat = Date.now();
    socketService.listen(function () { return lastHeartbeat = Date.now(); }, "heartbeat");
    socketService.on("connect", function () {
        console.info("connect at " + Date.now() + " after " + (Date.now() - lastHeartbeat));
        if (Date.now() - lastHeartbeat > LONG_DISCONNECT) {
            scheduleInstancesUpdate(UpdateEvent.wake);
        }
        else {
            scheduleInstancesUpdate(UpdateEvent.blink);
        }
        lastHeartbeat = Date.now();
    });
    var pauseStarted = 0;
    document.addEventListener("pause", function () { return pauseStarted = Date.now(); }, false);
    document.addEventListener("resume", function () {
        console.info("ended pause at " + Date.now() + " after " + (Date.now() - pauseStarted));
        if (Date.now() - pauseStarted > LONG_APP_PAUSE) {
            scheduleInstancesUpdate(UpdateEvent.wake);
        }
        else {
            scheduleInstancesUpdate(UpdateEvent.blink);
        }
    }, false);
    return _b = /** @class */ (function () {
            function ObjectLoader() {
            }
            ObjectLoader.getLoaded = function (id) {
                if (!ObjectLoader.isLoaded(id)) {
                    throw new Error("Not yet loaded: " + id);
                }
                return byId[id].instance;
            };
            ObjectLoader.isLoaded = function (id) {
                return byId.hasOwnProperty(id);
            };
            ObjectLoader.load = function (source) {
                var id = getID(source);
                if (byId[id]) {
                    serverResponseToInstance(source, id, byId[id].instance);
                    return Bluebird.resolve(byId[id].instance);
                }
                if (!loading[id]) {
                    loading = __assign({}, loading, (_a = {}, _a[id] = loadFromCache(id)
                        .catch(function () { return serverResponseToInstance(source, id, null); }), _a));
                }
                return loading[id];
                var _a;
            };
            ObjectLoader.updateCache = function (id, cacheableData) {
                return cache.store(id, cacheableData);
            };
            // Throws
            ObjectLoader.getFromCache = function (id) {
                if (byId[id]) {
                    return Bluebird.resolve(byId[id].instance);
                }
                return loadFromCache(id);
            };
            ObjectLoader.get = function (id) {
                if (typeof id === "undefined" || id === null) {
                    throw new Error("Can't get object with id " + id + " - " + cacheName);
                }
                if (byId[id]) {
                    return Bluebird.resolve(byId[id].instance);
                }
                if (!loading[id]) {
                    var promise = loadFromCache(id)
                        .catch(function () { return download(id, null).then(function (response) { return serverResponseToInstance(response, id, null); }); });
                    loading = __assign({}, loading, (_a = {}, _a[id] = promise, _a));
                }
                return loading[id];
                var _a;
            };
            return ObjectLoader;
        }()),
        _b.getAll = function () {
            return byId;
        },
        _b.removeLoaded = function (id) { return delete byId[id]; },
        _b.addLoaded = function (id, obj) {
            byId[id] = { instance: obj, lastUpdated: Date.now(), updating: false };
        },
        _b;
    var _b;
}
export default createLoader;



//////////////////
// WEBPACK FOOTER
// ./js/services/mutableObjectLoader.ts
// module id = H35O
// module chunks = 1 2 3